module.exports = __webpack_public_path__ + "static/refund-mobile-7818f3d1d875c8fa86d77476ea5bdd4d.png";